import React from 'react';

import { ARROW_LENGTH, ARROW_SIZE, COLOR_ICON, COLOR_SELECT_ROW_GANT } from '../const';
import { getPointXByGeometryParamDragItem, getPointYByGeometryParamDragItem } from '../functions';
import useGetGeometryParamForItem from '../hooks/useGetGeometryParamForItem';
import { DraggableGantType, ItemType } from '../types';

interface IGantGridArrow {
    endItem: ItemType | null;
    draggingEnd: DraggableGantType;
    propsArrowLine: React.SVGLineElementAttributes<SVGLineElement>;
    selectArrow: boolean;
}

const GantGridArrow: React.FC<IGantGridArrow> = ({ endItem, draggingEnd, propsArrowLine, selectArrow }) => {
    const geometryParamEndItem = useGetGeometryParamForItem(endItem);

    const pointEndX = getPointXByGeometryParamDragItem(draggingEnd, geometryParamEndItem);
    const pointEndY = getPointYByGeometryParamDragItem(geometryParamEndItem);

    const outlinePath = `M${pointEndX + length}, ${pointEndY} 
                   L${pointEndX + length - ARROW_SIZE},${pointEndY - ARROW_LENGTH} 
                   L${pointEndX + length + ARROW_SIZE},${pointEndY - ARROW_LENGTH}Z`;

    return (
        <>
            <path
                d={outlinePath}
                fill={selectArrow ? COLOR_SELECT_ROW_GANT : COLOR_ICON}
                transform={`rotate(${draggingEnd === 'bondLeft' ? -90 : 90}, ${pointEndX}, ${pointEndY})`}
                {...propsArrowLine}
            />
        </>
    );
};

export default React.memo(GantGridArrow);
